export const ROOT_COLLECTION = '__root_collection__';
export const BILLING_TYPE = 'billing';
export const ITEMS_PER_PAGE = [20, 40, 100];
